// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gCcT","title":"styles_title__v8aJw"};